import React from "react";
import BlurryImage from "../Components/BlurryImage.component";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/splide/dist/css/splide.min.css";
const SOCIALPROOF = [
  {
    img: "Images/partners/boulangerie.jpg",
    alt: "boulangerie",
  },
  {
    img: "Images/partners/boutique.jpg",
    alt: "boutique",
  },
  {
    img: "Images/partners/djahel.jpg",
    alt: "djahel",
  },
  {
    img: "./Images/partners/epicerie.jpg",
    alt: "epicerie",
  },
  {
    img: "./Images/partners/epicerie1.jpg",
    alt: "epicerie",
  },
  {
    img: "./Images/partners/ets.jpg",
    alt: "ets",
  },
  {
    img: "./Images/partners/longrish.jpg",
    alt: "lougrich",
  },
  {
    img: "./Images/partners/hotel.jpg",
    alt: "hotel",
  },
  {
    img: "./Images/partners/mutuel.jpg",
    alt: "mutuel",
  },
  {
    img: "./Images/partners/poissonerie.jpg",
    alt: "pharmacie",
  },
  {
    img: "./Images/partners/pharmatie.jpg",
    alt: "pharmacie",
  },
  {
    img: "./Images/partners/sombacam.jpg",
    alt: "sombacam",
  },
  {
    img: "./Images/partners/topmodel.jpg",
    alt: "topmodel",
  },
];
const SocialProofContainer = () => {
  return (
    <div className="social-proof-ctn">
      <Splide
        options={{
          type: "loop",
          rewind: true,
          //autoplay: true,
          width: "100%",
          height: "150px",
          arrows: false,
          pagination: false,
          drag: "free",
          focus: "center",
          perPage: 6,
          autoScroll: {
            speed: -1,
          },
          snap: true,
          breakpoints: {
            1260: {
              perPage: 5,
            },
            810: {
              perPage: 3,
            },
            612: {
              height: "130px",
            },
            400: {
              height: "100px",
            },
          },
        }}
        extensions={{ AutoScroll }}
      >
        {SOCIALPROOF.map((s, i) => (
          <SplideSlide className="socialctn" key={i}>
            <img className="cover" alt={s.alt} src={s.img} />
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
};

export default SocialProofContainer;
